module.exports = __webpack_public_path__ + "static/img/bg@2x.d436a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/bg@2x.png
// module id = b11D
// module chunks = 1